import { getProjects } from "../data/projectsClient.js";
import { weeklyCacheGeneration } from "./projectWeeklyCache.js";

const store = new Map();
const pending = new Map();
const TTL_MS = 60_000;
export function projectAlertSnapshot(authIdentity) {
  const entry = store.get(authIdentity);
  return entry && entry.generation === weeklyCacheGeneration() && Date.now() < entry.expires ? entry.data : null;
}
export function readAlertProjects(authIdentity) {
  const data = projectAlertSnapshot(authIdentity);
  if (data) return Promise.resolve(data);
  const generation = weeklyCacheGeneration();
  const key = JSON.stringify([authIdentity, generation]);
  if (pending.has(key)) return pending.get(key);
  const request = Promise.resolve().then(() => getProjects()).then(rows => {
    if (generation === weeklyCacheGeneration()) {
      store.set(authIdentity, { data: rows, generation, expires: Date.now() + TTL_MS });
    }
    return rows;
  }).finally(() => {
    if (pending.get(key) === request) pending.delete(key);
  });
  pending.set(key, request);
  return request;
}
